// extracted by mini-css-extract-plugin
export default {"mainButtonElement":"Pc0kp6","buttonPrimary":"LkdEGs","buttonSecondary":"fbUprw"};